module.exports = __webpack_public_path__ + "static/media/scotland.debf3b1a.png";